import { render, staticRenderFns } from "./LineupBase.vue?vue&type=template&id=c3dea60e&scoped=true&"
import script from "./LineupBase.vue?vue&type=script&lang=js&"
export * from "./LineupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dea60e",
  null
  
)

export default component.exports